CustomValidateDirective = ->
  require: 'ngModel'
  restrict: 'A'
  scope:
    customValidate: '&gnpCustomValidate'
  link: (scope, elem, attrs, ctrl) ->
    scope.$watch ->
      ctrl.$modelValue
    , (newValue) ->
      if newValue
        valid = scope.customValidate(value: newValue)
        ctrl.$setValidity "customValidate", valid
      else
        ctrl.$setValidity "customValidate", true

module.exports = CustomValidateDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/form/custom-validate-directive.coffee